import SVGIcon from '../../../assets/images/svg/SVGIcon';
import { useMobileDevice } from '../../../global/useMobile';
import { Cards, Details, Icon, LeftContent, RevokeIcon, TitleSection } from './styles';
import ButtonV2 from '../../../component/button/buttonV2';
import { BUTTON_TYPE } from '../../../global/constants';

interface Props {
  iconName: string;
  title: string;
  location?: string;
  lastSeen: string;
  onRevoke?: () => void;
}

const DeviceCard: React.FC<Props> = ({ iconName, lastSeen, title, onRevoke }) => {
  const mobile = useMobileDevice();

  return (
    <Cards>
      <LeftContent>
        <Icon>
          <SVGIcon name={iconName} width='18' height='18' viewBox='0 0 18 18' fill='var(--text-secondary)' />
        </Icon>
        <TitleSection>
          <h2>{title}</h2>
          <Details>
            {/* <p>{location}</p>
          <DotIcon>
            <Dot />
          </DotIcon> */}
            <p>{lastSeen}</p>
          </Details>
        </TitleSection>
      </LeftContent>
      {!mobile ? (
        <ButtonV2
          title='Revoke'
          variant={BUTTON_TYPE.SECONDARY}
          size='small'
          onClick={onRevoke}
          className='revoke-button'
        />
      ) : (
        <RevokeIcon onClick={onRevoke}>
          <SVGIcon name='exit-icon' width='18' height='18' viewBox='0 0 18 18' fill='var(--text-secondary)' />
        </RevokeIcon>
      )}
    </Cards>
  );
};

export default DeviceCard;
